import { useCallback, useEffect, useState } from "react";

import { useValues, useFormActions } from "2g-form/hooks";

import { useKonfiguracniParametry } from "b2b/api/hooks";
import { useZadostiObsazenost } from "b2b/api/hooks";

export default function useRezervaceVytoverniScheduler() {
  const values = useValues() || {};
  const { setValue } = useFormActions();
  const { getHodnotaByKod, loaded } = useKonfiguracniParametry();
  const { data: obsazenost } = useZadostiObsazenost({
    datumOd:
      values.datumOd && values.datumOd < values.obdobiOd
        ? values.datumOd
        : values.obdobiOd,
    datumDo:
      values.datumDo && values.datumDo > values.obdobiDo
        ? values.datumDo
        : values.obdobiDo,
    zakaznik: values.zakaznik,
    uzivatel: values.uzivatel,
    projekt: values.projekt,
    zdroj: values.zdroj?.zdroj,
    produkt: values.produkt?.produkt
  });
  const [enabledHoursSmena, setEnabledHoursSmena] = useState([]);

  const prvniSmenaCas =
    loaded && Number.parseInt(getHodnotaByKod("SMENA_POCATECNI_CAS_DNE"));
  const semenaPocetHodin =
    loaded && Number.parseInt(getHodnotaByKod("SMENA_POCET_HODIN"));
  const semenaPocet =
    loaded && Number.parseInt(getHodnotaByKod("SMENA_POCET_SMEN"));

  const findObsazenostForDay = day => {
    return obsazenost.find(obsazenostItem => {
      const obsazenostDen = new Date(obsazenostItem.den);
      return (
        day.getFullYear() == obsazenostDen.getFullYear() &&
        day.getMonth() == obsazenostDen.getMonth() &&
        day.getDate() == obsazenostDen.getDate()
      );
    });
  };

  const isBusy = useCallback(
    (day, hour) => {
      const obsazenostZaznam = findObsazenostForDay(day);
      return !obsazenostZaznam?.lzeZadat[hour];
    },
    [obsazenost]
  );

  const isEnabledForFrom = useCallback(
    (day, hour) => {
      const pozadavekSmena = values.zdroj.zdroj.pozadavekSmena;

      return (
        !isBusy(day, hour) &&
        (!pozadavekSmena || enabledHoursSmena.includes(hour))
      );
    },
    [enabledHoursSmena, values.zdroj, isBusy]
  );

  const isEnabledForTo = useCallback(
    (day, hour) => {
      return !isBusy(day, hour);
    },
    [isBusy]
  );

  useEffect(() => {
    if (loaded) {
      const enabledHours = [prvniSmenaCas];
      while (enabledHours.length < semenaPocet) {
        enabledHours.push(enabledHours.slice(-1)[0] + semenaPocetHodin);
      }
      setEnabledHoursSmena(enabledHours);
    }
  }, [loaded, prvniSmenaCas, semenaPocetHodin, semenaPocet]);

  const onChange = useCallback(
    ({ scheduledFrom, scheduledTo }) => {
      if (values.zdroj?.zdroj.pozadavekSmena) {
        scheduledTo = new Date(scheduledFrom);
        scheduledTo.setHours(scheduledTo.getHours() + (semenaPocetHodin - 1));
      }
      setValue(["datumOd"], scheduledFrom);
      setValue(["datumDo"], scheduledTo);
    },
    [setValue, values.zdroj]
  );

  return {
    from: values.obdobiOd,
    to: values.obdobiDo,
    scheduledFrom: values.datumOd,
    scheduledTo: values.datumDo,
    isBusy,
    isEnabledForFrom,
    isEnabledForTo,
    onChange,
    visible:
      obsazenost &&
      values.obdobiOd &&
      values.obdobiDo &&
      values.produkt &&
      !values.produkt?.produkt?.bezCasu &&
      values.zakaznik &&
      values.uzivatel &&
      values.projekt
  };
}
